import axios from 'axios';
import { logger, sendError } from '~/api/loggerLogic';
import logMapRequest from '~/utils/logs-utils/logMapRequest';
import logMapResponse from '~/utils/logs-utils/logMapResponse';
import { useGlobalStore } from '~/stores/global';

const globalAPI = `https://${
  import.meta.env?.VITE_PRICE_HOST || 'price.ru'
}/v4`;

export const API = axios.create({
  baseURL: import.meta.env.SSR ? globalAPI : '/v4/',
  headers: {
    common: {},
  },
});

API.interceptors.request.use(
  (config) => {
    // @ts-ignore
    config.start = new Date();
    logger.info(logMapRequest(config, new Date()));
    return config;
  },
  (error) => {
    sendError(error);
    return Promise.reject(error);
  }
);
API.interceptors.response.use(
  (response) => {
    const responseStart =
      'start' in response.config ? response.config.start : new Date();
    logger.info(
      logMapResponse(response, {
        start: responseStart as Date,
        end: new Date(),
      })
    );
    if (responseStart) {
      const globalStore = useGlobalStore();
      const isShowConsole =
        typeof import.meta.env.VITE_VIEW_LOG_TIME !== 'undefined' &&
        import.meta.env.VITE_VIEW_LOG_TIME === 'true';
      if (isShowConsole) {
        console.error(
          'Время запроса: ',
          +new Date() - +responseStart,
          ' url: ',
          response.config.url
        );
      }
      globalStore.addRequestSumTime(+new Date() - +responseStart);
    }
    return response;
  },
  (error) => {
    sendError(error);
    return Promise.reject(error);
  }
);
